'use client';

import React, { FC } from 'react';
import Script from 'next/script';
import smartFormProps from '@/libs/interfaceProps/smartFormProps';
import Skeleton from './Skeleton';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useLangContext } from '@/context/langContext';
const SmartForm: FC<smartFormProps> = ({
  resId,
  peId,
  hasVendorQuestions = true,
  language = 'en',
  redirectionUrl,
  userUrl,
  customerLink,
  isLoading
}) => {
  const t = useTranslations('Asset');
  // Get search params from URL.
  const searchParams = useSearchParams();
  // Get bt_tok param from URL.
  const btTok = searchParams.get('bt_tok');
  // Check if the bt_tok parameter exists.
  const hasBtTok = searchParams.has('bt_tok');
  const {
    lang
  } = useLangContext();
  type SupportedLang = 'en' | 'de' | 'es' | 'fr' | 'pt' | 'ko' | 'zh' | 'jp';
  function getSiteId(lang: SupportedLang): string {
    const id: Record<SupportedLang, string> = {
      en: '3225',
      de: '1225',
      es: '1224',
      fr: '1223',
      pt: '1226',
      ko: '1227',
      zh: '1228',
      jp: '1222'
    };
    return id[lang];
  }
  function getSiteName(lang: SupportedLang): string {
    const id: Record<SupportedLang, string> = {
      en: 'contenthub',
      de: 'contentHubGerman',
      es: 'contentHubSpanish',
      fr: 'contentHubFrench',
      pt: 'contentHubPortuguese',
      ko: 'contentHubKorea',
      zh: 'contentHubChina',
      jp: 'contentHubJapan'
    };
    return id[lang];
  }
  return <>
   <Script type="module" src={`${userUrl ? userUrl : 'https://users.techtarget.com'}/registration/v2/ui/smartforms-techtarget/smartforms-techtarget.esm.js`} data-sentry-element="Script" data-sentry-source-file="SmartForm.tsx" />
   {isLoading && <Skeleton />}
   <smartforms-techtarget current-screen="lead-drop" resource-id={resId} btn-width="100%" header-text={t('DownloadNow')} btn-text={t('Download')} app-code="151" site-id={getSiteId(lang)} site-name={getSiteName(lang)} standalone="false" pe-key={peId} has-vendor-questions={hasVendorQuestions} language={language} redirection-url={redirectionUrl} customer-link={customerLink} bt_tok={hasBtTok ? btTok : ''} data-sentry-element="smartforms-techtarget" data-sentry-source-file="SmartForm.tsx" />
  </>;
};
export default SmartForm;